import React, {useEffect, useRef, useState} from 'react';
import Cards from './components/ScheduleCards';
import { getScheduleCard } from './api/scheduleApi';
import { FadeIn, FadeInUp } from "../../shared/ui/animations";
import styles from "./schedule.module.css";

const ScheduleSection = () => {
    const [isOpenGamesSelected, setIsOpenGamesSelected] = useState(true);

    const [openGames, setOpenGames] = useState([
        // {
        //     id: 1,
        //     startedAt: "2025-06-01T18:00:00",
        //     catalogCard: {
        //         title: "Cyberpunk Edgerunners: Куртка",
        //         description: "2076 год. системе жизнь, системе системе  системе системе системе и и системе системе системе, навязанной мегакорпорациями,," +
        //             " запретного. Ты — эдджраннер. запретного. Ты — эдджраннер. Работать в одиночку — " +
        //             "самоубийство, поэтому ты примкнул к команде. Вы прикрываете друг друга и компенсируете самоубийство, поэтому ты примкнул к команде. самоубийство, поэтому ты примкнул к команде. Вы прикрываете друг друга и компенсируете " +
        //             "слабости товарищей в деле. И это хорошо, потому что сегодня у вас есть работа. и и и и и и",
        //         imageUrl: "https://storage.yandexcloud.net/dnd-images/8426542f-3576-4776-aaab-e2cd5979c6b8-image.png",
        //         cost: 800.0,
        //         gameSystemName: "game1",
        //         sessionFormatName: "Ваншот"
        //     },
        //     masterName: "SuperAdmin",
        //     minDurationHours: 2,
        //     maxDurationHours: 5,
        //     freeCountPlayers: 6,
        //     maxCountPlayers: 6,
        //     isButtonActive: true
        // },
    ]);
    const [closedGames, setClosedGames] = useState([
        // {
        //     id: 1,
        //     startedAt: "2025-06-01T18:00:00",
        //     catalogCard: {
        //         title: "хуй хуй хуй хуй",
        //         description: "2076 год. системе жизнь, системе системе  системе системе системе и и системе системе системе, навязанной мегакорпорациями,," +
        //             " запретного. Ты — эдджраннер. запретного. Ты — эдджраннер. Работать в одиночку — " +
        //             "самоубийство, поэтому ты примкнул к команде. Вы прикрываете друг друга и компенсируете самоубийство, поэтому ты примкнул к команде. самоубийство, поэтому ты примкнул к команде. Вы прикрываете друг друга и компенсируете " +
        //             "слабости товарищей в деле. И это хорошо, потому что сегодня у вас есть работа. и и и и и и",
        //         imageUrl: "https://storage.yandexcloud.net/dnd-images/8426542f-3576-4776-aaab-e2cd5979c6b8-image.png",
        //         cost: 800.0,
        //         gameSystemName: "game1",
        //         sessionFormatName: "Ваншот"
        //     },
        //     masterName: "SuperAdmin",
        //     minDurationHours: 2,
        //     maxDurationHours: 5,
        //     freeCountPlayers: 6,
        //     maxCountPlayers: 6,
        //     isButtonActive: true
        // },
    ]);

    const [pageOpenGames, setPageOpenGames] = useState(0);
    const [pageClosedGames, setPageClosedGames] = useState(0);

    const [lastPageOpenGames, setLastPageOpenGames] = useState(false);
    const [lastPageClosedGames, setLastPageClosedGames] = useState(false);

    const [isLoadingOpen, setIsLoadingOpen] = useState(false);
    const [isLoadingClosed, setIsLoadingClosed] = useState(false);

    const [, setError] = useState(null);


    const tabsSliderRef = useRef(null);

    useEffect(() => {
        const loadGames = async () => {
            try {
                setIsLoadingOpen(true);
                const resOpen = await getScheduleCard(0, 3, "OPEN");
                setOpenGames(resOpen.data.content);
                setPageOpenGames(1);
                setLastPageOpenGames(resOpen.data.last);

                setIsLoadingClosed(true);
                const resClosed = await getScheduleCard(0, 3, "CLOSE");
                setClosedGames(resClosed.data.content);
                setPageClosedGames(1);
                setLastPageClosedGames(resClosed.data.last);
            } catch (e) {
                console.error(e);
                setError("Ошибка загрузки игр");
            } finally {
                setIsLoadingOpen(false);
                setIsLoadingClosed(false);
            }
        };

        loadGames();
    }, []);

    const loadOpenGames = async () => {
        setIsLoadingOpen(true);
        setError(null);
        try {
            const res = await getScheduleCard(pageOpenGames, 3, "OPEN");
            setOpenGames(prev => [...prev, ...res.data.content]);
            setPageOpenGames(prev => prev + 1);
            setLastPageOpenGames(res.data.last);
        } catch (err) {
            console.error(err);
            setError("Ошибка загрузки открытых игр");
        } finally {
            setIsLoadingOpen(false);
        }
    };

    const loadClosedGames = async () => {
        setIsLoadingClosed(true);
        setError(null);
        try {
            const res = await getScheduleCard(pageClosedGames, 3, "CLOSE");
            setClosedGames(prev => [...prev, ...res.data.content]);
            setPageClosedGames(prev => prev + 1);
            setLastPageClosedGames(res.data.last);
        } catch (err) {
            console.error(err);
            setError("Ошибка загрузки закрытых игр");
        } finally {
            setIsLoadingClosed(false);
        }
    };

    const handleTabClick = (isOpen) => {
        setIsOpenGamesSelected(isOpen);

        if (isOpen && openGames?.length === 0) {
            loadOpenGames();
        } else if (!isOpen && closedGames?.length === 0) {
            loadClosedGames();
        }

        setTimeout(() => {
            if (!tabsSliderRef.current) {
                return;
            }

            const slider = tabsSliderRef.current;
            const buttons = slider.querySelectorAll('.btnTabScroll');

            if (buttons.length < 2) {
                return;
            }

            const activeButton = isOpen ? buttons[0] : buttons[1];
            if (!activeButton) {
                return;
            }

            const buttonRect = activeButton.getBoundingClientRect();
            const sliderRect = slider.getBoundingClientRect();

            const scrollLeft = buttonRect.left - sliderRect.left + slider.scrollLeft - (sliderRect.width - buttonRect.width) / 2;

            const maxScroll = slider.scrollWidth - slider.clientWidth;
            const safeScrollLeft = Math.max(0, Math.min(scrollLeft, maxScroll));

            slider.scrollTo({
                left: safeScrollLeft,
                behavior: 'smooth'
            });

        }, 100);
    };

    const currentCards = isOpenGamesSelected ? openGames : closedGames;
    const currentLoading = isOpenGamesSelected ? isLoadingOpen : isLoadingClosed;
    const currentLastPage = isOpenGamesSelected ? lastPageOpenGames : lastPageClosedGames;
    const onLoadMore = isOpenGamesSelected ? loadOpenGames : loadClosedGames;

    return (
        <section className="scheduleSection" id="scheduleSection">
            <div className="container-custom withContainer">
                <FadeInUp>
                    <p className="body section-title">Расписание</p>
                </FadeInUp>

                <div className={`row g-0`}>
                        <div className={styles.tabsSliderContainer} ref={tabsSliderRef}>
                            <FadeIn delay={200}>
                                <div className={`${styles.tabsSlider} ${styles.buttonsTabsWrapper}`}>
                                <button
                                    onClick={() => handleTabClick(true)}
                                    className={`btn btn-tab-green btnTabScroll ${styles.btnTab} ${isOpenGamesSelected ? styles.active : ''}`}
                                >
                                    Открытые игры
                                </button>
                                <button
                                    onClick={() => handleTabClick(false)}
                                    className={`btn btn-tab-green btnTabScroll ${styles.btnTab} ${!isOpenGamesSelected ? styles.active : ''}`}
                                >
                                    Закрытые игры
                                </button>
                            </div>
                            </FadeIn>
                        </div>
                </div>
            </div>

            <Cards cards={currentCards} onLoadMore={onLoadMore} isLoading={currentLoading} lastPage={currentLastPage} />
        </section>
    );
};

export default ScheduleSection;
